import { render, staticRenderFns } from "./borrowbook.vue?vue&type=template&id=b57d6bf2"
import script from "./borrowbook.vue?vue&type=script&lang=js"
export * from "./borrowbook.vue?vue&type=script&lang=js"
import style0 from "./borrowbook.vue?vue&type=style&index=0&id=b57d6bf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports